















import { defineComponent, ref, watch, onMounted } from '@vue/composition-api';

export default defineComponent({
  name: 'TxtPreview',
  props: {
    src: { type: String, required: true },
    name: { type: String, default: '' }
  },
  setup(props) {
    const status = ref<'loading' | 'error' | 'success'>('loading');
    const errorMsg = ref('');
    const text = ref('');

    async function load() {
      status.value = 'loading';
      errorMsg.value = '';
      text.value = '';

      try {
        const response = await fetch(props.src);
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        text.value = await response.text();
        status.value = 'success';
      } catch (err: any) {
        status.value = 'error';
        errorMsg.value = err?.message || 'Failed to load';
      }
    }

    onMounted(() => {
      load();
    });

    watch(() => props.src, () => {
      load();
    });

    return { status, errorMsg, text };
  }
});
